import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledButtonContainer = styled(Flex)`
    justify-content: center;
`;
